// extracted by mini-css-extract-plugin
export default {"diferenciais-container":"NossosDiferenciais_diferenciais-container__Iwzq1","diferenciais-grid":"NossosDiferenciais_diferenciais-grid__iTafY"};